import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import TagNewForm from './forms/CreateTagForm';
import {
    fetchVocabularies,
    fetchVocabularyLevels,
    fetchTagParents,
    createTag
} from './thunks';
import {
    selectedVocabularyId,
    selectedLevel,
    selectedParentTag,
    selectedTagName,
    selectedTagosId,
    clearFormFields
} from './actions';

class TagCreate extends Component {

    componentWillMount() {
        this.props.fetchVocabularies();
        this.props.clearFormFields();
    }

    handleCreateTagSubmit(tag) {
        this.props.createTag(this.props.tag);
    }

    render() {

        return (
            this.props.loading !== true &&
            <TagNewForm
                vocabularies={this.props.vocabularies}
                vocabularyLevels={this.props.vocabularyLevels}
                tagParents={this.props.tagParents}
                fetchVocabularyLevels={this.props.fetchVocabularyLevels}
                fetchTagParents={this.props.fetchTagParents}
                classes={this.props.classes}
                vocabularyId={this.props.vocabularyId}
                levelId={this.props.levelId}
                parentTagId={this.props.parentTagId}
                tagName={this.props.tagName}
                tagTagosId={this.props.tagTagosId}
                selectedVocabularyId={this.props.selectedVocabularyId}
                selectedLevel={this.props.selectedLevel}
                selectedParentTag={this.props.selectedParentTag}
                selectedTagName={this.props.selectedTagName}
                selectedTagosId={this.props.selectedTagosId}
                clearFormFields={this.props.clearFormFields}
                submitFormFields={this.handleCreateTagSubmit.bind(this)}
                touched={this.props.touched}
                loading={this.props.loading}
            />
        )
    }
}

const mapStateToProps = state => ({
    loading: state.layout.ajaxCallsInProgress > 0,
    tag: state.tags.tag,
    vocabularies: state.tags.vocabularies,
    vocabularyLevels: state.tags.vocabularyLevels,
    tagParents: state.tags.tagParents,
    vocabularyId: state.tags.tag.vocabulary_id,
    levelId: state.tags.tag.level,
    parentTagId: state.tags.tag.parent_id,
    tagName: state.tags.tag.display_name,
    tagTagosId: state.tags.tag.tagos_id,
    touched: state.tags.touched,
});

export default connect(mapStateToProps, {
    fetchVocabularies,
    fetchVocabularyLevels,
    fetchTagParents,
    selectedVocabularyId,
    selectedLevel,
    selectedParentTag,
    selectedTagName,
    selectedTagosId,
    createTag,
    clearFormFields
})(withStyles(styles)(TagCreate));


// WEBPACK FOOTER //
// ./src/containers/tags/TagCreate.jsx